import { getDayOfYear, getYear, endOfYesterday } from "date-fns";
import { getTimezoneOffset } from "date-fns-tz";

export const getCurrentTimezoneDate = (timezone) => {
  const newDate = new Date();
  const localOffset = newDate.getTimezoneOffset() * 60 * 1000;
  const timezoneOffset = getTimezoneOffset(timezone) || 0;
  const offset = localOffset + timezoneOffset;

  newDate.setTime(newDate.getTime() + offset);

  return newDate;
};

export const getYesterdayTimezonedDate = (timezone) => {
  const newDate = endOfYesterday();
  const localOffset = newDate.getTimezoneOffset() * 60 * 1000;
  const timezoneOffset = getTimezoneOffset(timezone) || 0;
  const offset = localOffset + timezoneOffset;

  newDate.setTime(newDate.getTime() + offset);

  return newDate;
};

export const dateToUTC = (date) => {
  const newDate = new Date();

  newDate.setTime(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));

  return newDate;
};

export const isToday = (date, timezone) => {
  const timezoneDate = getCurrentTimezoneDate(timezone);
  const dayOfYearTimezone = getDayOfYear(timezoneDate);
  const dayOfYear = getDayOfYear(date);

  if (dayOfYear !== dayOfYearTimezone) {
    return false;
  }

  const yearTimezone = getYear(timezoneDate);
  const year = getYear(date);

  return year === yearTimezone;
};
